<template>
    <div style="height: 100%;">
        <el-row :gutter="20" class="container">
            <!--左边树区-->
            <el-col :span="4" :xs="24" style="background-color: #FFFFFF;height: 100%;border-right: #ECECEC solid 0.01rem; padding: 0.3rem;overflow: auto;">
                <!--树区搜索框-->
                <el-input
                        v-model="treeSearch"
                        placeholder="请输入节点名称"
                        clearable
                        size="small"
                        prefix-icon="el-icon-search"
                        style="margin-bottom: 20px"
                />
                <!--树-->
                <el-tree
                        :data="tree.treeData"
                        :props="tree.defaultProps"
                        :expand-on-click-node="false"
                        :filter-node-method="filterNode"
                        ref="tree"
                        @node-click="handleNodeClick"
                />
            </el-col>
            <!--右边主要区-->
            <el-col :span="20" :xs="24" class="container" style="flex-direction: column;border-width: 0;padding-top: 25px;">
                    <!--右边头部搜索区-->
                    <el-form :model="queryParams.param" ref="queryForm" :inline="true" label-position="right" v-show="showSearch" label-width="110px">
                                <!-- 用户名 -->
                                <el-form-item :label="columnInfo.name.label" prop="name">
                                        <el-input v-model="queryParams.param.name" placeholder="请输入内容" size="small" clearable></el-input>
                                </el-form-item>
                                <!-- 登录名 -->
                                <el-form-item :label="columnInfo.loginName.label" prop="loginName">
                                        <el-input v-model="queryParams.param.loginName" placeholder="请输入内容" size="small" clearable></el-input>
                                </el-form-item>
                                <!-- 地区代码  关联组织表 -->
                                <el-form-item :label="columnInfo.dqCode.label" prop="dqCode">
                                        <el-input v-model="queryParams.param.dqCode" placeholder="请输入内容" size="small" clearable></el-input>
                                </el-form-item>
                                <!-- 职务id -->
                                <el-form-item :label="columnInfo.positionId.label" prop="positionId">
                                        <options-select v-model="queryParams.param.positionId" placeholder="请选择" size="small" :options="options.positionOptions"></options-select>
                                </el-form-item>
                                <!-- 手机号码 -->
                                <el-form-item :label="columnInfo.mobile.label" prop="mobile">
                                        <el-input v-model="queryParams.param.mobile" placeholder="请输入内容" size="small" clearable></el-input>
                                </el-form-item>
                                <!-- 邮箱 -->
                                <el-form-item :label="columnInfo.email.label" prop="email">
                                        <el-input v-model="queryParams.param.email" placeholder="请输入内容" size="small" clearable></el-input>
                                </el-form-item>
                                <!-- 是否开通登录账号  1=是 0=否 -->
                                <el-form-item :label="columnInfo.openAccount.label" prop="openAccount">
                                        <enum-dict-select v-model="queryParams.param.openAccount" dict-code="binary" module-name="system" size="small"></enum-dict-select>
                                </el-form-item>
                                <!-- 状态 1=有效 0=无效 -->
                                <el-form-item :label="columnInfo.state.label" prop="state">
                                        <enum-dict-select v-model="queryParams.param.state" dict-code="state" module-name="system" size="small"></enum-dict-select>
                                </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="small" @click="handleTableSearch">搜索</el-button>
                            <el-button icon="el-icon-refresh" size="small" @click="clickReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <!--右边中部功能区-->
                    <el-row :gutter="10" style="margin-bottom:13px;margin-right: 1px">
                        <el-col :span="1.5">
                            <el-button
                                    type="primary"
                                    plain
                                    icon="el-icon-plus"
                                    size="small"
                                    @click="clickAdd"
                                    v-permissionDisabled="'system:user:create'"
                            >新增</el-button>
                        </el-col>
                        <el-col :span="1.5">
                            <excel-import-plus title="系统用户表" module-name="system" table-name="user" :permission-code="'system:user:import'"></excel-import-plus>
                        </el-col>
                        <el-col :span="1.5">
                            <excel-export-plus file-name="系统用户表" module-name="system" table-name="user" :select-list="selectList" :permission-code="'system:user:export'"></excel-export-plus>
                        </el-col>
                        <el-col :span="1.5">
                            <excel-export-all file-name="系统用户表" module-name="system" table-name="user" :select-list="selectList" :permission-code="'system:user:export'"></excel-export-all>
                        </el-col>
                        <right-toolbar-plus :showSearch.sync="showSearch" @queryTable="handleTableSearch"
                                            :columnInfo="columnInfo" @redoTableLayout="redoTableLayout"></right-toolbar-plus>
                    </el-row>
                    <!--右边中部表格区-->
                    <div class="main">
                        <div class="table">
                            <el-table border ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                                      @selection-change="handleSelectionChange" height="100%" :header-cell-style="{background:'#ECF5FF'}">
                                <el-table-column align="center" type="selection" width="55"/>
                                        <!-- 用户名 -->
                                        <af-table-column align="center" prop="name" :label="columnInfo.name.label" v-if="columnInfo.name.visible"></af-table-column>
                                        <!-- 登录名 -->
                                        <af-table-column align="center" prop="loginName" :label="columnInfo.loginName.label" v-if="columnInfo.loginName.visible" width="100"></af-table-column>
<!--                                        &lt;!&ndash; 登录密码 &ndash;&gt;-->
<!--                                        <af-table-column align="center" prop="loginPwd" :label="columnInfo.loginPwd.label" v-if="columnInfo.loginPwd.visible"></af-table-column>-->
                                        <!-- 地区代码  关联组织表 -->
                                        <af-table-column align="center" prop="dqCode" :label="columnInfo.dqCode.label" v-if="columnInfo.dqCode.visible"></af-table-column>
                                        <!-- 组织id -->
                                        <af-table-column align="center" prop="organizationId" :label="columnInfo.organizationId.label" v-if="columnInfo.organizationId.visible">
                                          <template v-slot="scope">
                                            <tree-option-name-label v-model="scope.row.organizationId" :tree-data="options.organizationTreeOptions"
                                                                    field-name="name" children-pros="childrenList"></tree-option-name-label>
                                          </template>
                                        </af-table-column>
                                        <!-- 职务id -->
                                        <af-table-column align="center" prop="positionId" :label="columnInfo.positionId.label" v-if="columnInfo.positionId.visible">
                                          <template v-slot="scope">
                                            <position-name-label v-model="scope.row.positionId"></position-name-label>
                                          </template>
                                        </af-table-column>
                                        <!-- 手机号码 -->
                                        <af-table-column align="center" prop="mobile" :label="columnInfo.mobile.label" v-if="columnInfo.mobile.visible"></af-table-column>
                                        <!-- 邮箱 -->
                                        <af-table-column align="center" prop="email" :label="columnInfo.email.label" v-if="columnInfo.email.visible" width="169"></af-table-column>
                                        <!-- 是否开通登录账号  1=是 0=否 -->
                                        <af-table-column align="center" prop="openAccount" :label="columnInfo.openAccount.label" v-if="columnInfo.openAccount.visible">
                                          <template v-slot="scope">
                                            <enum-dict-label v-model="scope.row.openAccount" module-name="system" dict-code="binary"
                                                             show-tag></enum-dict-label>
                                          </template>
                                        </af-table-column>
                                        <!-- 状态 1=有效 0=无效 -->
                                        <el-table-column align="center" prop="state" :label="columnInfo.state.label" v-if="columnInfo.state.visible">
                                          <template v-slot="scope">
                                            <enum-dict-label v-model="scope.row.state" module-name="system" dict-code="state"
                                                             show-tag></enum-dict-label>
                                          </template>
                                        </el-table-column>
                                <!-- 操作列 -->
                                <af-table-column align="center" label="操作" width="420" fixed="right">
                                    <template v-slot="scope">
                                      <el-button @click="clickEdit(scope.row)" type="primary" size="mini" v-permissionDisabled="'system:user:update'">编辑</el-button>
                                      <el-button @click="clickDel(scope.row)" type="danger" size="mini" v-permissionDisabled="'system:user:remove'">删除</el-button>
                                      <role-list-select-button @getCheckedIds="getCheckedIds({callback:$event,row:scope.row})" @getDescData="getDescData($event,scope.row)"
                                                                 @onClickConfirm="onRoleConfirm({checkedIds:arguments[0],callback:arguments[1],row:scope.row})"
                                      @onClickCancel="onRoleCancel"  >分配角色</role-list-select-button>
                                      <el-button @click="clickResetPassword(scope.row)" type="warning" size="mini" v-permissionDisabled="'system:user:resetPassword'">密码重置</el-button>
                                      <el-button @click="clickAuthorizationLogin(scope.row)" type="success" size="mini" v-permissionDisabled="'system:user:setOpenAccount'">开通登录</el-button>
                                    </template>
                                </af-table-column>
                            </el-table>
                        </div>
                    </div>
                    <!--右边底部分页区-->
                    <div style="height: 40px;margin-bottom: 0.1rem;">
                        <pagination-plus :totalCount="totalCount"
                                         :param="queryParams"
                                         :pageSizes="pageSizes"
                                         :selectList="selectList"
                                         module-name="system"
                                         table-name="user"
                                         :del-all-permission-code="'system:user:removes'"
                                         :state-permission-code="'system:user:state'"
                                         @handleTableRefresh="handleTableSearch"/>
                    </div>
                </el-col>
        </el-row>
        <!-- 弹出层组件 -->
        <UserForm/>
    </div>
</template>

<script>
    /**
     * 系统用户表主页面 （与自定义组件之间请遵循MVVM架构）
     * @author PeterLee
     * @since 2022-06-22
     */
    import UserForm from "./UserForm"
    import {mapState, mapMutations, mapActions} from "vuex";
    import MyPagination from "@/components/My-pagination";
    import RoleListSelect from "@/views/system/components/RoleListSelect";
    import PositionNameLabel from "@/components/label/PositionNameLabel";
    import RoleListSelectButton from "@/views/system/components/RoleListSelectButton";

    export default {
        components: {
            //表单弹出组件
            UserForm,
            MyPagination,
            RoleListSelect,
            PositionNameLabel,
            RoleListSelectButton
        },
        data() {
            return {
                //树节点搜索内容
                treeSearch: undefined,
                //每页条数选项（分页控件）
                pageSizes: [10, 20, 40, 80],
                //批量操作选中list（分页控件）
                selectList: [],
                //展示搜索区（right-toolbar）
                showSearch: false,
                //导出loading
                exportLoading: false,
            }
        },
        computed: {
            ...mapState({
                //表格数据
                tableData: state => state.system.user.tableData,
                //下拉选项
                options: state => state.system.user.options,
                //共有数据条数（分页控件）
                totalCount: state => state.system.user.totalCount,
                //列信息
                columnInfo: state => state.system.user.columnInfo,
                //查询参数
                queryParams: state => state.system.user.queryParams,
                //时间范围
                dateRange: state => state.system.user.dateRange,
                //更多按钮信息
                moreButtonProps: state => state.system.user.moreButtonProps,
                //树信息
                tree: state => state.system.user.tree
            })
        },
        watch: {
            //节点过滤监听
            treeSearch(val) {
               this.$refs.tree.filter(val);
            },
        },
        //生命周期create函数
        created() {
            //创建时获取所有权限数据（分页查询）
            this.handleTableSearch();
            //获取OptionList
            this.getOptionList();
        },
        methods: {
            ...mapMutations({
                clickEdit: 'system/user/clickEdit',
                clickAdd: 'system/user/clickAdd',
            }),
            ...mapActions({
                clickDel: 'system/user/handleDel',
                clickResetPassword: 'system/user/handleResetPassword',
                handleTableSearch: 'system/user/handleTableSearch',
                getOptionList: 'system/user/getOptionList',
                handleNodeClick: 'system/user/handleNodeClick',
                clickAuthorizationLogin: 'system/user/clickAuthorizationLogin',
                getCheckedIds: 'system/user/getRelationRoleIds',
                onRoleConfirm: 'system/user/relationRoles',
            }),
            /** 重置按钮点击（搜索区） */
            clickReset() {
                for (let key of Object.keys(this.dateRange)) {
                    this.dateRange[key] = []
                }
                this.$refs['queryForm'].resetFields();
                this.queryParams.param.organizationId='';
                this.handleTableSearch();
            },
            /** 处理选择改变（表格区） */
            handleSelectionChange(selectList) {
                this.selectList = selectList;
            },
            /** 重新计算表格（按钮区） */
            redoTableLayout() {
                //数据加载完成后执行
                this.$nextTick(() => {
                    //表格重新渲染
                    this.$refs.multipleTable.doLayout();
                });
            },
            /** 搜索框筛选节点 */
            filterNode(value, data) {
                if (!value) return true;
                //name为树数据展示名字段名（因实际情况而异）
                return data.name.indexOf(value) !== -1;
            },
            /** 更多按钮方法处理（按钮区） */
            handleCommand(command,row) {
                // console.log(command)
                // console.log(row)
            },
            /** 获取角色关联弹出框描述信息 */
            getDescData(callback,row) {
                callback(
                    [{
                      name: '用户名称',
                      value: row.name
                    },{
                      name: '登录名',
                      value: row.loginName
                    }]
                )
            },
            /** 分配角色取消按钮 */
            onRoleCancel(callback){
               callback()
            }
        }
    }
</script>

<style lang="less" scoped>
    @import url('~@/assets/style/index.less');

    ::v-deep .el-form-item {
        margin-bottom: 18px;
    }
</style>
